<template>
  <div class="wrapper">
    <side-bar>
      <mobile-menu slot="content"></mobile-menu>
      <sidebar-link to="/admin/overview">
        <i class="nc-icon nc-chart-pie-35"></i>
        <p>Dashboard</p>
      </sidebar-link>
      <sidebar-link v-if="!report" to="/admin/table-list">
        <i class="nc-icon nc-notes"></i>
        <p>Lista Tickets</p>
      </sidebar-link>
      <sidebar-link v-if="rol != 2" to="/admin/comprobantes">
        <i class="nc-icon nc-money-coins"></i>
        <p>Comprobantes</p>
      </sidebar-link>
      <sidebar-link v-if="rol != 2" to="/admin/parametros">
        <i class="nc-icon nc-settings-gear-64"></i>
        <p>Parámetros/Terceros</p>
      </sidebar-link>
      <sidebar-link v-if="rol != 2 || report" to="/admin/typography">
        <i class="nc-icon nc-paper-2"></i>
        <p>Reportes</p>
      </sidebar-link>
      <sidebar-link v-if="rol != 2" to="/admin/user">
        <i class="nc-icon nc-circle-09"></i>
        <p>Perfiles</p>
      </sidebar-link>
    </side-bar>

    <div class="main-panel">
      <top-navbar></top-navbar>
      <dashboard-content @click="toggleSidebar">
      </dashboard-content>
      <content-footer></content-footer>
    </div>
  </div>
</template>
<style lang="scss"></style>
<script>
import TopNavbar from './TopNavbar.vue'
import ContentFooter from './ContentFooter.vue'
import DashboardContent from './Content.vue'
import MobileMenu from './MobileMenu.vue'
import getSecret from '../helpers/get-secret';
const serverUrl = getSecret('SERVER_URL');
export default {
  components: {
    TopNavbar,
    ContentFooter,
    DashboardContent,
    MobileMenu
  },
  data() {
    return {
      id_company: JSON.parse(localStorage.getItem('jwt_licencia')).id_company,
      name_company: JSON.parse(localStorage.getItem('jwt_licencia')).name,
      token: window.localStorage.getItem('jwt_token'),
      email: JSON.parse(localStorage.getItem('jwt_user')).email,
      rol: JSON.parse(localStorage.getItem('jwt_user')).rol,
      report: JSON.parse(localStorage.getItem('jwt_user')).report
    }
  },
  methods: {
    toggleSidebar() {
      if (this.$sidebar.showSidebar) {
        this.$sidebar.displaySidebar(false)
      }
    },
    validateLogin() {
      if (this.token == null || this.token == undefined || this.token == "") {
        location.href = location.origin + '/#/login';
      }
      this.validate();
    },
    validate() {
      this.axios.post(serverUrl + '/api/validateToken', { email: this.email, token: this.token })
        .then(res => {
          if (res.data.status == "success") {
            //console.log("Token Valido");
          } else {
            console.log("Token Invalido");
            location.href = location.origin + '/#/login';
          }
        })
        .catch(err => {
          console.log(err.data);
        });
    }
  },
  mounted() {
    this.validateLogin();
  }
}

</script>
